import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Icon, Input } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const ListOrganization = function ({ match, history }) {
  // Settings form
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({})
  const { count, page, pageSize } = formatedData
  // Created component
  useEffect(() => {
    listOrganization(formValues)

    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  // Api requests
  async function listOrganization(params) {
    try {
      const response = await request(api.listOrganizations(params))
      console.tron.log('response listOrganization', response)
      const itens = response.items
      const formatedRows = []
      itens.map((item) => {
        return formatedRows.push({
          key: item.id,
          ...item,
          actions: formatActionsContent(item.id)
        })
      })
      setFormatedData({
        ...response,
        items: formatedRows,
        actions: 'teste'
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Formaters
  const columns = [
    {
      title: getMessage('organizationName'),
      dataIndex: 'organizationName'
    },

    {
      title: getMessage('addressComplement'),
      dataIndex: 'addressComplement'
    },

    {
      title: getMessage('zipCode'),
      dataIndex: 'zipCode'
    },

    {
      title: getMessage('neighborhood'),
      dataIndex: 'neighborhood'
    },

    {
      title: getMessage('addressNumber'),
      dataIndex: 'addressNumber'
    },

    {
      title: getMessage('addressDescription'),
      dataIndex: 'addressDescription'
    },

    {
      title: getMessage('cnpj'),
      dataIndex: 'cnpj'
    },

    {
      title: getMessage('emailAddress'),
      dataIndex: 'emailAddress'
    },

    {
      title: getMessage('phoneNumber'),
      dataIndex: 'phoneNumber'
    },

    {
      title: getMessage('edit'),
      dataIndex: 'actions'
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    listOrganization({
      page: current - 1,
      ...formValues
    })
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/organization/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  return (
    <>
      {/* @TODO alterar para padrão {renderHeader()} */}
      <div style={{ paddingBottom: '0.5rem' }}>
        <div>
          <Typography.Title level={3} style={{ margin: '0 0 0 0' }}>
            {getMessage('listOrganization')}
          </Typography.Title>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <CustomBreadcrumb match={match} history={history} />
        </div>
      </div>

      <Card className="ant-card gx-card ant-card-bordered">
        <Input.Search
          className="default-header-search"
          onSearch={(value) => listOrganization({ search: value })}
          placeholder={getMessage('search')}
        />
        <Table
          key="id"
          columns={columns}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListOrganization
